import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsAdd = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
     
      <path fill="currentColor" d="M12.6808739,11.3420515V0.5833333h-1.3640394v10.7587185H0.5833333v1.3640394h10.7335014V23.416666h1.3640394
	V12.7060909H23.416666v-1.3640394H12.6808739z"/>
    </SvgIcon>
  );
});

export default AppIconsAdd;
